export enum ButtonAction {
  Primary = 'primary',
  Danger = 'danger',
  Warning = 'warning',
  Cancel = 'cancel',
  Neutral = 'neutral',
  Inverse = 'inverse',
}

export interface ButtonActionClass {
  primary: string
  danger: string
  cancel: string
  warning: string
  neutral: string
  inverse: string
}

export enum ButtonSize {
  ExtraSmall = 'extraSmall',
  Small = 'small',
  Base = 'base',
  Large = 'large',
  ExtraLarge = 'extraLarge',
}

export interface ButtonSizeClass {
  extraSmall: string
  small: string
  base: string
  large: string
  extraLarge: string
}
